module.exports = __webpack_public_path__ + "media/svg/pk-4edcdce1.svg";